import React from 'react';

class MuteButton extends React.Component {
  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
  }

  onClick(event) {
    event.stopPropagation();
    event.preventDefault();
    try {
      if (this.props.muted) {
        this.props.video.muted = false;
        if (!this.props.video.volume) {
          this.props.video.volume = 1;
        }
      } else {
        this.props.video.muted = true;
      }
    } catch (e) {}
  }

  render() {
    var classes = 'b-mute';
    if (this.props.muted) {
      classes += ' muted';
    }
    return <div className={classes} onClick={this.onClick} onTouchEnd={this.onClick} />;
  }
}

export default MuteButton;
